// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2P_wE","clinicsSelect":"TableHeading_clinicsSelect__k3XJj"};